import { MatDialogConfig } from '@angular/material/dialog';

export enum DialogSize {
  XXL = '1600px',
  XL = '1200px',
  LG = '1000px',
  MD = '700px',
  SMD = '550px',
  SM = '450px',
  S = '350px',
  XS = '300px',
}
export const DIALOG_DEFAULT_CONFIG: MatDialogConfig = {
  width: DialogSize.SMD,
  autoFocus: false,
  restoreFocus: false,
};
